export enum LanguageCodeEnum {
  RU = 'ru',
  KK = 'kk',
}

export const LangCodeByCountry = {
  [LanguageCodeEnum.RU]: 'ru-KZ',
  [LanguageCodeEnum.KK]: 'kz-KK',
};

export const languages = [
  {
    label: 'Рус',
    code: LanguageCodeEnum.RU,
  },
  {
    label: 'Қаз',
    code: LanguageCodeEnum.KK,
  },
];

export const languageLabels = {
  [LanguageCodeEnum.RU]: 'Рус',
  [LanguageCodeEnum.KK]: 'Қаз',
};
